import { MoveStatus } from '../../../api/Inventory/Entities/InventoryMovementEntities';
import { buildDetailRowKey } from '../Shared/inventoryFormRules';

interface MoveDetailAssignment {
    kitNumber?: number | string | null;
}

interface MoveDetailItem {
    id?: number | string | null;
    presentation?: string | null;
    lotNumber?: string | null;
    quantity?: number | string | null;
    assignment?: MoveDetailAssignment | null;
    [key: string]: unknown;
}

interface MoveDetailRow extends MoveDetailItem {
    rowKey: string;
}

export function isCanceledMove(status: unknown): boolean {
    return (status ?? '').toString().toLowerCase() === MoveStatus.Canceled.Name.toLowerCase();
}

function buildGroupKey(item: MoveDetailItem): string {
    return [
        item?.presentation ?? '',
        item?.lotNumber ?? '',
        item?.assignment?.kitNumber ?? ''
    ].join('|');
}

// A cancellation of N units used to be persisted one row per unit; the ones stored before
// the backend started merging them are folded here so the detail reads the same either way.
export function resolveMoveDetailRows(
    items: Array<MoveDetailItem> | null | undefined,
    status: unknown
): Array<MoveDetailRow> {
    const rows = items ?? [];

    if (!isCanceledMove(status))
        return rows.map((item, index) => ({ ...item, rowKey: buildDetailRowKey(item, index) }));

    const grouped = new Map<string, MoveDetailRow>();

    rows.forEach((item, index) => {
        const key = buildGroupKey(item);
        const existing = grouped.get(key);
        const quantity = Number(item?.quantity) || 0;

        if (existing == null) {
            grouped.set(key, { ...item, quantity, rowKey: buildDetailRowKey(item, index) });
            return;
        }

        existing.quantity = (Number(existing.quantity) || 0) + quantity;
    });

    return Array.from(grouped.values());
}
